import { Avatar, Box, Flex, Text, TextProps } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { getLoggedInUser } from "@root/store/selectors/entities";
import { Sidebar } from "@root/components/dashboard/sidebar";
import { useLocation } from "react-router-dom";
import { ROUTE_NAMES } from "@root/constants";

interface ICustomText extends TextProps {
  text?: string;
  type?: "basicText" | "grayText" | "primary" | "purpleText";
  isEllipse?: boolean;
  gradient?: boolean;
  padding?: string | number;
  margin?: string | number;
  lineHeight?: string | number;
  showUserInfo?: boolean; // <-- Optional prop to toggle user display
  sidebar?: boolean;
  chat?: boolean;
  isUserChat?: boolean;
}

export const CustomText = (props: ICustomText) => {
  const user: any = useSelector(getLoggedInUser);
  const { pathname } = useLocation();

  const {
    text,
    color,
    textColor,
    type = "basicText",
    fontWeight = 400,
    fontSize = "14px",
    gradient = false,
    isEllipse = false,
    paddingTop = "0",
    paddingBottom = "0",
    margin = "0",
    sidebar,
    lineHeight = "normal",
    showUserInfo = true, // default true
    isUserChat = false,
    ...rest
  } = props;

  return (
    <Box margin={margin}>
      {/* User Info (Avatar + Name) */}
      {isUserChat && (
        <Flex align="center" mb="2">
          <Avatar size="sm" name={user?.name} src={user?.avatarUrl} mr="2" />
          <Text fontWeight="600" fontSize="15px">
            {user?.fullname}
          </Text>
        </Flex>
      )}

      {/* Main Text */}
      <Text
        color={
          gradient
            ? "transparent"
            : color || type === "basicText"
            ? "theme.text.primaryDark"
            : type === "grayText"
            ? "theme.gray.500"
            : type === "primary"
            ? "theme.button.primary"
            : type === "purpleText"
            ? "purple.500"
            : "theme.white"
        }
        textColor={textColor}
        fontSize={fontSize}
        fontWeight={fontWeight}
        isTruncated={isEllipse}
        maxWidth={isEllipse ? "200px" : "unset"}
        whiteSpace={isEllipse ? "nowrap" : "normal"}
        overflow={isEllipse ? "hidden" : "visible"}
        textOverflow={isEllipse ? "ellipsis" : "unset"}
        background={
          gradient
            ? "linear-gradient(90deg, #6950F3 36.15%, #AE40E0 64.08%)"
            : undefined
        }
        backgroundClip={gradient ? "text" : undefined}
        webkitBackgroundClip={gradient ? "text" : undefined}
        pt={paddingTop}
        pb={paddingBottom}
        lineHeight={lineHeight}
        {...rest}
      >
        {text}
      </Text>
    </Box>
  );
};
